<div *transloco="let t" class="roles-history">
	<div class="mb-3">
		<ara-button-toggle-group
			[value]="angle()"
			(valueChange)="onAngleChange($event)"
			color="primary"
			[attr.aria-label]="t('tenantunitDetails.editor.view.angle')">
			<button araButtonToggle value="role">{{ t('tenantunitDetails.editor.view.byRole') }}</button>
			<button araButtonToggle value="person">{{ t('tenantunitDetails.editor.view.byPerson') }}</button>
		</ara-button-toggle-group>
	</div>

	@if (angle() === 'role') {
		<div class="flex flex-col gap-4">
			@for (group of groupsByType(); track group.roleType) {
				<div class="history-group">
					<div class="history-group__title">{{ display.roleTypeLabel(group.roleType) }}</div>
					<div class="flex flex-col">
						@for (entry of group.entries; track roleTrackKey(entry.role); let last = $last) {
							<div class="history-row" [class.history-row--last]="last">
								<span class="w-2 h-2 rounded-full shrink-0" [class.bg-green]="entry.isOpen" [class.bg-gray]="!entry.isOpen"></span>
								<button araButton size="xs" type="button" class="history-name" (click)="emitOpen(entry.roleModel)">
									{{ display.personName(entry.roleModel) }}
								</button>
								<ara-generic-chip [label]="display.periodLabel(entry.role)"></ara-generic-chip>
							</div>
						}
					</div>
				</div>
			}
		</div>
	} @else {
		<div class="flex flex-col gap-3">
			@for (entry of byPerson(); track entry.roleModel.person.id) {
				<div class="history-group">
					<button araButton size="xs" type="button" class="history-name history-name--lg" (click)="emitOpen(entry.roleModel)">
						{{ display.personName(entry.roleModel) }}
					</button>
					<div class="flex flex-row flex-wrap items-center gap-1.5 mt-2">
						@for (item of entry.roles; track roleTrackKey(item.role)) {
							<span class="inline-flex items-center gap-1">
								<span class="w-2 h-2 rounded-full shrink-0" [class.bg-green]="item.isOpen" [class.bg-gray]="!item.isOpen"></span>
								<ara-generic-chip
									[label]="display.roleTypeLabel(item.role.roleType) + '  ' + display.periodLabel(item.role)"></ara-generic-chip>
							</span>
						}
					</div>
				</div>
			}
		</div>
	}
</div>
